import { createStyleFunction } from 'utils/ui';
import { ellipsis, visuallyHidden, overflowWrap as wrap } from 'styles/mixins';
export var overflowStylesMap = {
  ellipsis: ellipsis,
  wrap: wrap
};
function getOverflowValue(value) {
  if (value in overflowStylesMap) {
    return overflowStylesMap[value];
  } else {
    return {
      overflow: value
    };
  }
}
export var displayPropsDef = [{
  styleProp: 'display',
  getValue: function getValue(display) {
    return display;
  }
}, {
  styleProp: 'overflow',
  getRules: getOverflowValue
}, {
  styleProp: 'overflowX',
  getValue: function getValue(display) {
    return display;
  }
}, {
  styleProp: 'overflowY',
  getValue: function getValue(display) {
    return display;
  }
}, {
  styleProp: 'pointerEvents',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'cursor',
  getValue: function getValue(value) {
    return value;
  }
}, {
  styleProp: 'visuallyHidden',
  getRules: function getRules(value) {
    return value ? visuallyHidden : undefined;
  }
}];
export default createStyleFunction(displayPropsDef);